<template>
  <div class="animated fadeIn">
    <!-- Header Premium -->
    <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
      <div class="d-flex align-items-center p-3 flex-shrink-0">
        <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
          <i class="fa fa-exclamation-triangle text-white"></i>
        </div>
        <div class="header-text-container">
          <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Painel de Cancelamentos e Alterações</h4>
          <p class="text-muted mb-0 small d-none d-lg-block">Monitoramento de alterações e exclusões do sistema</p>
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
        <!-- Filtro de Período -->
        <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
          <b-button-group class="mr-2 d-none d-lg-inline-flex">
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
              <i class="fa fa-file-excel-o"></i>
            </b-button>
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
              <i class="fa fa-print"></i>
            </b-button>
            <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
              <i class="fa fa-ban"></i>
            </b-button>
          </b-button-group>

          <b-button-group class="mr-2 d-lg-none">
            <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
              <i class="fa fa-ban"></i>
            </b-button>
          </b-button-group>

          <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
            <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
            <span class="text-muted mx-1">até</span>
            <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
          </div>
          <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
            <i class="fa fa-search mr-1"></i> FILTRAR
          </b-button>
        </div>
      </div>
    </div>

    <!-- Vendas com Datas Diferentes -->
    <b-card :bg-variant="isDark ? 'dark' : ''" class="mb-3">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="mb-2 mb-md-0">
            <i class="fa fa-calendar text-warning mr-2"></i>
            <strong>Vendas com Data de Faturamento Diferente da Data Real</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small mr-2">{{ vendasDiferentes.length }} registro(s)</span>
            <b-button size="sm" variant="outline-primary" @click="imprimirVendasDatas()" v-b-tooltip.hover title="Imprimir PDF">
              <i class="fa fa-print"></i>
            </b-button>
          </div>
        </div>
      </b-card-title>
      <b-overlay :show="isBusyVendas" rounded="sm">
        <b-table 
          ref="tblVendas"
          class="modern-premium-table"
          :dark="isDark"
          responsive hover small show-empty
          empty-text="Nenhum registro encontrado"
          :items="itensFiltrados1"
          :fields="fieldsVendasDiferentes"
          :sticky-header="stickyHeight"
        >
          <template #head(SEQUENCIA)>
            <set-filter
              label="ID"
              v-model="filtros1.SEQUENCIA"
              :options="opcoes1.SEQUENCIA"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(N_VENDA)>
            <set-filter
              label="Pedido"
              v-model="filtros1.N_VENDA"
              :options="opcoes1.N_VENDA"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(NOME_CLIENTE)>
            <set-filter
              label="Cliente"
              v-model="filtros1.NOME_CLIENTE"
              :options="opcoes1.NOME_CLIENTE"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(USUARIO)>
            <set-filter
              label="Usuário"
              v-model="filtros1.USUARIO"
              :options="opcoes1.USUARIO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #cell(SEQUENCIA)="data">{{ data.value }}</template>
          <template #cell(N_VENDA)="data">{{ data.value }}</template>
          <template #cell(NOME_CLIENTE)="data">{{ data.value }}</template>
          <template #cell(USUARIO)="data">{{ data.value }}</template>
          <template #cell(DT_CADASTRO_SISTEMA)="data">{{ formatarData(data.value) }}</template>
          <template #cell(DT_SAIDA)="data">{{ formatarData(data.value) }}</template>
          <template #cell(VL_TOTAL)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(DIFERENCA)="data">
            <b-badge :variant="data.value > 0 ? 'success' : 'danger'">{{ data.value }} dias</b-badge>
          </template>
        </b-table>
        <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap" v-if="itensFiltrados1.length">
          <strong>Total: {{ formatarMoeda(totalVendasDiferentesFiltrado) }}</strong>
          <span class="text-muted">{{ itensFiltrados1.length }} registro(s)</span>
        </div>
      </b-overlay>
    </b-card>

    <!-- Alterações de Vendas -->
    <b-card :bg-variant="isDark ? 'dark' : ''" class="mb-3">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="mb-2 mb-md-0">
            <i class="fa fa-edit text-info mr-2"></i>
            <strong>Alterações de Vendas</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small mr-2">{{ alteracoesVendas.length }} registro(s)</span>
            <b-button size="sm" variant="outline-primary" @click="imprimirAlteracoes()" v-b-tooltip.hover title="Imprimir PDF">
              <i class="fa fa-print"></i>
            </b-button>
          </div>
        </div>
      </b-card-title>
      <b-overlay :show="isBusyAlteracoes" rounded="sm">
        <b-table 
          ref="tblAlteracoes"
          class="modern-premium-table"
          :dark="isDark"
          responsive hover small show-empty
          empty-text="Nenhum registro encontrado"
          :items="itensFiltrados2"
          :fields="fieldsAlteracoesVendas"
          :sticky-header="stickyHeight"
        >
          <template #head(SEQUENCIA)>
            <set-filter
              label="ID"
              v-model="filtros2.SEQUENCIA"
              :options="opcoes2.SEQUENCIA"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(N_VENDA)>
            <set-filter
              label="Pedido"
              v-model="filtros2.N_VENDA"
              :options="opcoes2.N_VENDA"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(NOME_CLIENTE)>
            <set-filter
              label="Cliente"
              v-model="filtros2.NOME_CLIENTE"
              :options="opcoes2.NOME_CLIENTE"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(STATUS)>
            <set-filter
              label="Status"
              v-model="filtros2.STATUS"
              :options="opcoes2.STATUS"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #cell(SEQUENCIA)="data">{{ data.value }}</template>
          <template #cell(N_VENDA)="data">{{ data.value }}</template>
          <template #cell(NOME_CLIENTE)="data">{{ data.value }}</template>
          <template #cell(OBSERVACAO)="data">
            <span v-b-tooltip.hover :title="data.value">{{ (data.value || '').substring(0, 30) }}{{ data.value && data.value.length > 30 ? '...' : '' }}</span>
          </template>
          <template #cell(TX_USUARIO_ALTERACAO)="data">{{ data.value }}</template>
          <template #cell(DT_ALTERACAO)="data">{{ formatarData(data.value) }}</template>
          <template #cell(DT_ALTERACAO_SISTEMA)="data">{{ formatarData(data.value) }}</template>
          <template #cell(VL_TOTAL_ANTES_ALTERACAO)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(VL_TOTAL)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(DIFERENCA)="data">
            <span :class="data.value > 0 ? 'text-success' : (data.value < 0 ? 'text-danger' : 'text-muted')">
              {{ formatarMoeda(data.value) }}
            </span>
          </template>
          <template #cell(STATUS)="data">
            <b-badge :variant="data.value === 'VL. AUMENTOU' ? 'success' : (data.value === 'VL. DIMINUIU' ? 'danger' : 'secondary')">
              {{ data.value }}
            </b-badge>
          </template>
        </b-table>
        <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap" v-if="itensFiltrados2.length">
          <div>
            <strong>Valor Antes: {{ formatarMoeda(totalAlteracoesAntesFiltrado) }}</strong>
            <strong class="ml-3">Valor Depois: {{ formatarMoeda(totalAlteracoesDepoisFiltrado) }}</strong>
            <strong class="ml-3">Diferença: {{ formatarMoeda(totalAlteracoesDiferencaFiltrado) }}</strong>
          </div>
          <span class="text-muted">{{ itensFiltrados2.length }} registro(s)</span>
        </div>
      </b-overlay>
    </b-card>

    <!-- A Receber Excluídas -->
    <b-card :bg-variant="isDark ? 'dark' : ''" class="mb-3">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="mb-2 mb-md-0">
            <i class="fa fa-trash text-danger mr-2"></i>
            <strong>Contas a Receber Excluídas</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small mr-2">{{ areceberExcluidas.length }} registro(s)</span>
            <b-button size="sm" variant="outline-primary" @click="imprimirAReceber()" v-b-tooltip.hover title="Imprimir PDF">
              <i class="fa fa-print"></i>
            </b-button>
          </div>
        </div>
      </b-card-title>
      <b-overlay :show="isBusyAReceber" rounded="sm">
        <b-table 
          ref="tblAReceber"
          class="modern-premium-table"
          :dark="isDark"
          responsive hover small show-empty
          empty-text="Nenhum registro encontrado"
          :items="itensFiltrados3"
          :fields="fieldsAReceberExcluidas"
          :sticky-header="stickyHeight"
        >
          <template #head(DOCUMENTO)>
            <set-filter
              label="Documento"
              v-model="filtros3.DOCUMENTO"
              :options="opcoes3.DOCUMENTO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(NOME_CLIENTE)>
            <set-filter
              label="Cliente"
              v-model="filtros3.NOME_CLIENTE"
              :options="opcoes3.NOME_CLIENTE"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(USUARIO)>
            <set-filter
              label="Usuário"
              v-model="filtros3.USUARIO"
              :options="opcoes3.USUARIO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #cell(DOCUMENTO)="data">{{ data.value }}</template>
          <template #cell(PARCELAS)="data">{{ data.value }}</template>
          <template #cell(NOME_CLIENTE)="data">{{ data.value }}</template>
          <template #cell(USUARIO)="data">{{ data.value }}</template>
          <template #cell(DT_SISTEMA)="data">{{ formatarData(data.value) }}</template>
          <template #cell(DT_CANC)="data">{{ formatarData(data.value) }}</template>
          <template #cell(VL_DOC)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(VL_ARECEBER)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(DIFERENCA)="data">
            <b-badge :variant="data.value > 0 ? 'success' : 'danger'">{{ data.value }} dias</b-badge>
          </template>
        </b-table>
        <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap" v-if="itensFiltrados3.length">
          <div>
            <strong>Valor Doc: {{ formatarMoeda(totalAReceberDocFiltrado) }}</strong>
            <strong class="ml-3">Valor a Receber: {{ formatarMoeda(totalAReceberValorFiltrado) }}</strong>
          </div>
          <span class="text-muted">{{ itensFiltrados3.length }} registro(s)</span>
        </div>
      </b-overlay>
    </b-card>

    <!-- A Pagar Excluídas -->
    <b-card :bg-variant="isDark ? 'dark' : ''" class="mb-3">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="mb-2 mb-md-0">
            <i class="fa fa-trash text-warning mr-2"></i>
            <strong>Contas a Pagar Excluídas</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small mr-2">{{ apagarExcluidas.length }} registro(s)</span>
            <b-button size="sm" variant="outline-primary" @click="imprimirAPagar()" v-b-tooltip.hover title="Imprimir PDF">
              <i class="fa fa-print"></i>
            </b-button>
          </div>
        </div>
      </b-card-title>
      <b-overlay :show="isBusyAPagar" rounded="sm">
        <b-table 
          ref="tblAPagar"
          class="modern-premium-table"
          :dark="isDark"
          responsive hover small show-empty
          empty-text="Nenhum registro encontrado"
          :items="itensFiltrados4"
          :fields="fieldsAPagarExcluidas"
          :sticky-header="stickyHeight"
        >
          <template #head(DOCUMENTO)>
            <set-filter
              label="Documento"
              v-model="filtros4.DOCUMENTO"
              :options="opcoes4.DOCUMENTO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(NOME_CLIENTE)>
            <set-filter
              label="Fornecedor"
              v-model="filtros4.NOME_CLIENTE"
              :options="opcoes4.NOME_CLIENTE"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(USUARIO)>
            <set-filter
              label="Usuário"
              v-model="filtros4.USUARIO"
              :options="opcoes4.USUARIO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #cell(DOCUMENTO)="data">{{ data.value }}</template>
          <template #cell(PARCELAS)="data">{{ data.value }}</template>
          <template #cell(NOME_CLIENTE)="data">{{ data.value }}</template>
          <template #cell(USUARIO)="data">{{ data.value }}</template>
          <template #cell(DT_SISTEMA)="data">{{ formatarData(data.value) }}</template>
          <template #cell(DT_CANC)="data">{{ formatarData(data.value) }}</template>
          <template #cell(VL_DOC)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(VL_APAGAR)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(DIFERENCA)="data">
            <b-badge :variant="data.value > 0 ? 'success' : 'danger'">{{ data.value }} dias</b-badge>
          </template>
        </b-table>
        <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap" v-if="itensFiltrados4.length">
          <div>
            <strong>Valor Doc: {{ formatarMoeda(totalAPagarDocFiltrado) }}</strong>
            <strong class="ml-3">Valor a Pagar: {{ formatarMoeda(totalAPagarValorFiltrado) }}</strong>
          </div>
          <span class="text-muted">{{ itensFiltrados4.length }} registro(s)</span>
        </div>
      </b-overlay>
    </b-card>

    <!-- Monitoramento do Caixa -->
    <b-card :bg-variant="isDark ? 'dark' : ''" class="mb-3">
      <b-card-title>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div class="mb-2 mb-md-0">
            <i class="fa fa-money text-success mr-2"></i>
            <strong>Monitoramento do Caixa</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small mr-2">{{ monitoramentoCaixa.length }} registro(s)</span>
            <b-button size="sm" variant="outline-primary" @click="imprimirCaixa()" v-b-tooltip.hover title="Imprimir PDF">
              <i class="fa fa-print"></i>
            </b-button>
          </div>
        </div>
      </b-card-title>
      <b-overlay :show="isBusyCaixa" rounded="sm">
        <b-table 
          ref="tblCaixa"
          class="modern-premium-table"
          :dark="isDark"
          responsive hover small show-empty
          empty-text="Nenhum registro encontrado"
          :items="itensFiltrados5"
          :fields="fieldsMonitoramentoCaixa"
          :sticky-header="stickyHeight"
        >
          <template #head(DOCUMENTO)>
            <set-filter
              label="Documento"
              v-model="filtros5.DOCUMENTO"
              :options="opcoes5.DOCUMENTO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(NOME_HISTORICO)>
            <set-filter
              label="Histórico"
              v-model="filtros5.NOME_HISTORICO"
              :options="opcoes5.NOME_HISTORICO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(USUARIO_LOG)>
            <set-filter
              label="Usuário"
              v-model="filtros5.USUARIO_LOG"
              :options="opcoes5.USUARIO_LOG"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #head(TIPO)>
            <set-filter
              label="Tipo"
              v-model="filtros5.TIPO"
              :options="opcoes5.TIPO"
              :normalizeFn="normalize"
              :dropdown-variant="isDark ? 'dark' : 'none'"
            />
          </template>
          <template #cell(DOCUMENTO)="data">{{ data.value }}</template>
          <template #cell(CONTA_ID)="data">{{ data.value }}</template>
          <template #cell(CONTA_LOG_ID)="data">{{ data.value }}</template>
          <template #cell(NOME_HISTORICO)="data">{{ data.value }}</template>
          <template #cell(OBS)="data">
            <span v-b-tooltip.hover :title="data.value">{{ (data.value || '').substring(0, 30) }}{{ data.value && data.value.length > 30 ? '...' : '' }}</span>
          </template>
          <template #cell(USUARIO_LOG)="data">{{ data.value }}</template>
          <template #cell(DT_MOV)="data">{{ formatarData(data.value) }}</template>
          <template #cell(DT_LOG)="data">{{ formatarData(data.value) }}</template>
          <template #cell(VL_MOV)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(VL_LOG)="data">{{ formatarMoeda(data.value) }}</template>
          <template #cell(TIPO)="data">
            <b-badge :variant="data.value === 'EXCLUIDO' ? 'danger' : (data.value === 'ALTERADO' ? 'warning' : 'info')">
              {{ data.value }}
            </b-badge>
          </template>
        </b-table>
        <div class="mt-3 d-flex justify-content-between align-items-center flex-wrap" v-if="itensFiltrados5.length">
          <div>
            <strong>Valor Antes: {{ formatarMoeda(totalCaixaAntesFiltrado) }}</strong>
            <strong class="ml-3">Valor Depois: {{ formatarMoeda(totalCaixaDepoisFiltrado) }}</strong>
          </div>
          <span class="text-muted">{{ itensFiltrados5.length }} registro(s)</span>
        </div>
      </b-overlay>
    </b-card>

  </div>
</template>

<script>
import axios from 'axios'
import Tools from '@/tools/tools.js'
import { printHtmlReport, exportExcelXlsx } from '@/utils/RelatorioHTML'
import SetFilter from '@/components/Cec/SetFilter.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { normalize as _norm } from '@/utils/filtrosTabela.js'

export default {
  name: 'PainelCancelamentos',
  
  components: {
    SetFilter,
    CecInputData
  },
  
  data() {
    return {
      dt1: null,
      dt2: null,
      isBusy: false,
      isBusyVendas: false,
      isBusyAlteracoes: false,
      isBusyAReceber: false,
      isBusyAPagar: false,
      isBusyCaixa: false,
      vendasDiferentes: [],
      alteracoesVendas: [],
      areceberExcluidas: [],
      apagarExcluidas: [],
      monitoramentoCaixa: [],
      stickyHeight: '60vh',
      
      // Filtros para cada tabela
      filtros1: {},
      filtros2: {},
      filtros3: {},
      filtros4: {},
      filtros5: {},
      
      fieldsVendasDiferentes: [
        { key: 'SEQUENCIA', label: 'ID', sortable: true, class: 'align-middle text-right', thStyle: { width: '8%' }},
        { key: 'N_VENDA', label: 'Pedido', sortable: true, class: 'align-middle text-right', thStyle: { width: '8%' }},
        { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true, class: 'align-middle', thStyle: { width: '25%' }},
        { key: 'USUARIO', label: 'Usuário', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'DT_CADASTRO_SISTEMA', label: 'Dt. Sistema', sortable: true, class: 'align-middle text-center', thStyle: { width: '12%' }},
        { key: 'DT_SAIDA', label: 'Dt. Evento', sortable: true, class: 'align-middle text-center', thStyle: { width: '12%' }},
        { key: 'VL_TOTAL', label: 'Vl. Venda', sortable: true, class: 'align-middle text-right', thStyle: { width: '12%' }},
        { key: 'DIFERENCA', label: 'Dif. Dias', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }}
      ],
      
      fieldsAlteracoesVendas: [
        { key: 'SEQUENCIA', label: 'ID', sortable: true, class: 'align-middle text-right', thStyle: { width: '6%' }},
        { key: 'N_VENDA', label: 'Pedido', sortable: true, class: 'align-middle text-right', thStyle: { width: '7%' }},
        { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true, class: 'align-middle', thStyle: { width: '18%' }},
        { key: 'OBSERVACAO', label: 'Motivo', sortable: true, class: 'align-middle', thStyle: { width: '15%' }},
        { key: 'TX_USUARIO_ALTERACAO', label: 'Usuário', sortable: true, class: 'align-middle', thStyle: { width: '10%' }},
        { key: 'DT_ALTERACAO', label: 'Dt. Evento', sortable: true, class: 'align-middle text-center', thStyle: { width: '9%' }},
        { key: 'DT_ALTERACAO_SISTEMA', label: 'Dt. Sistema', sortable: true, class: 'align-middle text-center', thStyle: { width: '9%' }},
        { key: 'VL_TOTAL_ANTES_ALTERACAO', label: 'Vl. Antes', sortable: true, class: 'align-middle text-right', thStyle: { width: '9%' }},
        { key: 'VL_TOTAL', label: 'Vl. Depois', sortable: true, class: 'align-middle text-right', thStyle: { width: '9%' }},
        { key: 'DIFERENCA', label: 'Diferença', sortable: true, class: 'align-middle text-right', thStyle: { width: '8%' }},
        { key: 'STATUS', label: 'Status', sortable: true, class: 'align-middle text-center', thStyle: { width: '10%' }}
      ],
      
      fieldsAReceberExcluidas: [
        { key: 'DOCUMENTO', label: 'Documento', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'PARCELAS', label: 'Parcela', sortable: true, class: 'align-middle text-center', thStyle: { width: '8%' }},
        { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true, class: 'align-middle', thStyle: { width: '25%' }},
        { key: 'USUARIO', label: 'Usuário', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'DT_SISTEMA', label: 'Dt. Sistema', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }},
        { key: 'DT_CANC', label: 'Dt. Evento', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }},
        { key: 'VL_DOC', label: 'Vl. Documento', sortable: true, class: 'align-middle text-right', thStyle: { width: '10%' }},
        { key: 'VL_ARECEBER', label: 'Vl. a Receber', sortable: true, class: 'align-middle text-right', thStyle: { width: '10%' }},
        { key: 'DIFERENCA', label: 'Dif. Dias', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }}
      ],
      
      fieldsAPagarExcluidas: [
        { key: 'DOCUMENTO', label: 'Documento', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'PARCELAS', label: 'Parcela', sortable: true, class: 'align-middle text-center', thStyle: { width: '8%' }},
        { key: 'NOME_CLIENTE', label: 'Fornecedor', sortable: true, class: 'align-middle', thStyle: { width: '25%' }},
        { key: 'USUARIO', label: 'Usuário', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'DT_SISTEMA', label: 'Dt. Sistema', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }},
        { key: 'DT_CANC', label: 'Dt. Evento', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }},
        { key: 'VL_DOC', label: 'Vl. Documento', sortable: true, class: 'align-middle text-right', thStyle: { width: '10%' }},
        { key: 'VL_APAGAR', label: 'Vl. a Pagar', sortable: true, class: 'align-middle text-right', thStyle: { width: '10%' }},
        { key: 'DIFERENCA', label: 'Dif. Dias', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' }}
      ],
      
      fieldsMonitoramentoCaixa: [
        { key: 'DOCUMENTO', label: 'Documento', sortable: true, class: 'align-middle', thStyle: { width: '10%' }},
        { key: 'CONTA_ID', label: 'Conta Antes', sortable: true, class: 'align-middle text-center', thStyle: { width: '8%' }},
        { key: 'CONTA_LOG_ID', label: 'Conta Depois', sortable: true, class: 'align-middle text-center', thStyle: { width: '8%' }},
        { key: 'NOME_HISTORICO', label: 'Histórico', sortable: true, class: 'align-middle', thStyle: { width: '15%' }},
        { key: 'OBS', label: 'Descrição', sortable: true, class: 'align-middle', thStyle: { width: '12%' }},
        { key: 'USUARIO_LOG', label: 'Usuário', sortable: true, class: 'align-middle', thStyle: { width: '10%' }},
        { key: 'DT_MOV', label: 'Dt. Evento', sortable: true, class: 'align-middle text-center', thStyle: { width: '9%' }},
        { key: 'DT_LOG', label: 'Dt. Sistema', sortable: true, class: 'align-middle text-center', thStyle: { width: '9%' }},
        { key: 'VL_MOV', label: 'Vl. Antes', sortable: true, class: 'align-middle text-right', thStyle: { width: '8%' }},
        { key: 'VL_LOG', label: 'Vl. Depois', sortable: true, class: 'align-middle text-right', thStyle: { width: '8%' }},
        { key: 'TIPO', label: 'Tipo', sortable: true, class: 'align-middle text-center', thStyle: { width: '9%' }}
      ]
    }
  },
  
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    },
    
    // Opções de filtro para cada tabela
    opcoes1() {
      const map = {}
      const keys = ['SEQUENCIA', 'N_VENDA', 'NOME_CLIENTE', 'USUARIO', 'STATUS']
      keys.forEach(key => {
        const values = [...new Set(this.vendasDiferentes.map(item => item[key]))]
        map[key] = values.filter(v => v != null).sort().map(v => ({ value: v, text: String(v) }))
      })
      return map
    },
    
    opcoes2() {
      const map = {}
      const keys = ['SEQUENCIA', 'N_VENDA', 'NOME_CLIENTE', 'STATUS']
      keys.forEach(key => {
        const values = [...new Set(this.alteracoesVendas.map(item => item[key]))]
        map[key] = values.filter(v => v != null).sort().map(v => ({ value: v, text: String(v) }))
      })
      return map
    },
    
    opcoes3() {
      const map = {}
      const keys = ['DOCUMENTO', 'NOME_CLIENTE', 'USUARIO']
      keys.forEach(key => {
        const values = [...new Set(this.areceberExcluidas.map(item => item[key]))]
        map[key] = values.filter(v => v != null).sort().map(v => ({ value: v, text: String(v) }))
      })
      return map
    },
    
    opcoes4() {
      const map = {}
      const keys = ['DOCUMENTO', 'NOME_CLIENTE', 'USUARIO']
      keys.forEach(key => {
        const values = [...new Set(this.apagarExcluidas.map(item => item[key]))]
        map[key] = values.filter(v => v != null).sort().map(v => ({ value: v, text: String(v) }))
      })
      return map
    },
    
    opcoes5() {
      const map = {}
      const keys = ['DOCUMENTO', 'NOME_HISTORICO', 'USUARIO_LOG', 'TIPO']
      keys.forEach(key => {
        const values = [...new Set(this.monitoramentoCaixa.map(item => item[key]))]
        map[key] = values.filter(v => v != null).sort().map(v => ({ value: v, text: String(v) }))
      })
      return map
    },
    
    // Itens filtrados para cada tabela
    itensFiltrados1() {
      let items = this.vendasDiferentes
      Object.keys(this.filtros1).forEach(key => {
        const selected = this.filtros1[key]
        if (selected && selected.length > 0) {
          items = items.filter(item => selected.includes(item[key]))
        }
      })
      return items
    },
    
    itensFiltrados2() {
      let items = this.alteracoesVendas
      Object.keys(this.filtros2).forEach(key => {
        const selected = this.filtros2[key]
        if (selected && selected.length > 0) {
          items = items.filter(item => selected.includes(item[key]))
        }
      })
      return items
    },
    
    itensFiltrados3() {
      let items = this.areceberExcluidas
      Object.keys(this.filtros3).forEach(key => {
        const selected = this.filtros3[key]
        if (selected && selected.length > 0) {
          items = items.filter(item => selected.includes(item[key]))
        }
      })
      return items
    },
    
    itensFiltrados4() {
      let items = this.apagarExcluidas
      Object.keys(this.filtros4).forEach(key => {
        const selected = this.filtros4[key]
        if (selected && selected.length > 0) {
          items = items.filter(item => selected.includes(item[key]))
        }
      })
      return items
    },
    
    itensFiltrados5() {
      let items = this.monitoramentoCaixa
      Object.keys(this.filtros5).forEach(key => {
        const selected = this.filtros5[key]
        if (selected && selected.length > 0) {
          items = items.filter(item => selected.includes(item[key]))
        }
      })
      return items
    },
    
    totalVendasDiferentes() {
      return this.vendasDiferentes.reduce((acc, item) => acc + (item.VL_TOTAL || 0), 0)
    },
    
    totalVendasDiferentesFiltrado() {
      return this.itensFiltrados1.reduce((acc, item) => acc + (item.VL_TOTAL || 0), 0)
    },
    
    totalAlteracoesAntes() {
      return this.alteracoesVendas.reduce((acc, item) => acc + (item.VL_TOTAL_ANTES_ALTERACAO || 0), 0)
    },
    
    totalAlteracoesDepois() {
      return this.alteracoesVendas.reduce((acc, item) => acc + (item.VL_TOTAL || 0), 0)
    },
    
    totalAlteracoesDiferenca() {
      return this.totalAlteracoesDepois - this.totalAlteracoesAntes
    },
    
    totalAlteracoesAntesFiltrado() {
      return this.itensFiltrados2.reduce((acc, item) => acc + (item.VL_TOTAL_ANTES_ALTERACAO || 0), 0)
    },
    
    totalAlteracoesDepoisFiltrado() {
      return this.itensFiltrados2.reduce((acc, item) => acc + (item.VL_TOTAL || 0), 0)
    },
    
    totalAlteracoesDiferencaFiltrado() {
      return this.totalAlteracoesDepoisFiltrado - this.totalAlteracoesAntesFiltrado
    },
    
    totalAReceberDoc() {
      return this.areceberExcluidas.reduce((acc, item) => acc + (item.VL_DOC || 0), 0)
    },
    
    totalAReceberValor() {
      return this.areceberExcluidas.reduce((acc, item) => acc + (item.VL_ARECEBER || 0), 0)
    },
    
    totalAReceberDocFiltrado() {
      return this.itensFiltrados3.reduce((acc, item) => acc + (item.VL_DOC || 0), 0)
    },
    
    totalAReceberValorFiltrado() {
      return this.itensFiltrados3.reduce((acc, item) => acc + (item.VL_ARECEBER || 0), 0)
    },
    
    totalAPagarDoc() {
      return this.apagarExcluidas.reduce((acc, item) => acc + (item.VL_DOC || 0), 0)
    },
    
    totalAPagarValor() {
      return this.apagarExcluidas.reduce((acc, item) => acc + (item.VL_APAGAR || 0), 0)
    },
    
    totalAPagarDocFiltrado() {
      return this.itensFiltrados4.reduce((acc, item) => acc + (item.VL_DOC || 0), 0)
    },
    
    totalAPagarValorFiltrado() {
      return this.itensFiltrados4.reduce((acc, item) => acc + (item.VL_APAGAR || 0), 0)
    },
    
    totalCaixaAntes() {
      return this.monitoramentoCaixa.reduce((acc, item) => acc + (item.VL_MOV || 0), 0)
    },
    
    totalCaixaDepois() {
      return this.monitoramentoCaixa.reduce((acc, item) => acc + (item.VL_LOG || 0), 0)
    },
    
    totalCaixaAntesFiltrado() {
      return this.itensFiltrados5.reduce((acc, item) => acc + (item.VL_MOV || 0), 0)
    },
    
    totalCaixaDepoisFiltrado() {
      return this.itensFiltrados5.reduce((acc, item) => acc + (item.VL_LOG || 0), 0)
    }
  },
  
  methods: {
    normalize(str) {
      return _norm(String(str))
    },
    
    formatarData(data) {
      if (!data) return '-'
      try {
        if (data instanceof Date) {
          return data.toLocaleDateString('pt-BR')
        }
        const date = new Date(data)
        if (isNaN(date.getTime())) return data
        return date.toLocaleDateString('pt-BR')
      } catch (e) {
        return data
      }
    },
    
    formatarMoeda(valor) {
      if (valor === null || valor === undefined) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    },
    
    limparFiltro() {
      this.dt1 = null
      this.dt2 = null
      this.vendasDiferentes = []
      this.alteracoesVendas = []
      this.areceberExcluidas = []
      this.apagarExcluidas = []
      this.monitoramentoCaixa = []
    },
    
    async pesquisar() {
      if (!this.dt1 || !this.dt2) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o período para pesquisa!')
        return
      }
      
      this.isBusy = true
      
      try {
        // Buscar todas as informações em paralelo
        await Promise.all([
          this.buscarVendasDiferentes(),
          this.buscarAlteracoesVendas(),
          this.buscarAReceberExcluidas(),
          this.buscarAPagarExcluidas(),
          this.buscarMonitoramentoCaixa()
        ])
        
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Dados carregados com sucesso!')
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar dados!')
      } finally {
        this.isBusy = false
      }
    },
    
    async buscarVendasDiferentes() {
      this.isBusyVendas = true
      try {
        const response = await axios.get('/api/protected/painel-cancelamentos/vendas-datas-diferentes', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })
        this.vendasDiferentes = response.data || []
      } catch (error) {
        console.error('Erro ao buscar vendas com datas diferentes:', error)
        this.vendasDiferentes = []
      } finally {
        this.isBusyVendas = false
      }
    },
    
    async buscarAlteracoesVendas() {
      this.isBusyAlteracoes = true
      try {
        const response = await axios.get('/api/protected/painel-cancelamentos/alteracoes-vendas', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })
        this.alteracoesVendas = response.data || []
      } catch (error) {
        console.error('Erro ao buscar alterações de vendas:', error)
        this.alteracoesVendas = []
      } finally {
        this.isBusyAlteracoes = false
      }
    },
    
    async buscarAReceberExcluidas() {
      this.isBusyAReceber = true
      try {
        const response = await axios.get('/api/protected/painel-cancelamentos/areceber-excluidas', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })
        this.areceberExcluidas = response.data || []
      } catch (error) {
        console.error('Erro ao buscar a receber excluídas:', error)
        this.areceberExcluidas = []
      } finally {
        this.isBusyAReceber = false
      }
    },
    
    async buscarAPagarExcluidas() {
      this.isBusyAPagar = true
      try {
        const response = await axios.get('/api/protected/painel-cancelamentos/apagar-excluidas', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })
        this.apagarExcluidas = response.data || []
      } catch (error) {
        console.error('Erro ao buscar a pagar excluídas:', error)
        this.apagarExcluidas = []
      } finally {
        this.isBusyAPagar = false
      }
    },
    
    async buscarMonitoramentoCaixa() {
      this.isBusyCaixa = true
      try {
        const response = await axios.get('/api/protected/painel-cancelamentos/monitoramento-caixa', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })
        this.monitoramentoCaixa = response.data || []
      } catch (error) {
        console.error('Erro ao buscar monitoramento de caixa:', error)
        this.monitoramentoCaixa = []
      } finally {
        this.isBusyCaixa = false
      }
    },
    
    exportarHtml() {
      const allData = [
        { title: 'Vendas com Datas Diferentes', data: this.vendasDiferentes, fields: this.fieldsVendasDiferentes },
        { title: 'Alterações de Vendas', data: this.alteracoesVendas, fields: this.fieldsAlteracoesVendas },
        { title: 'A Receber Excluídas', data: this.areceberExcluidas, fields: this.fieldsAReceberExcluidas },
        { title: 'A Pagar Excluídas', data: this.apagarExcluidas, fields: this.fieldsAPagarExcluidas },
        { title: 'Monitoramento do Caixa', data: this.monitoramentoCaixa, fields: this.fieldsMonitoramentoCaixa }
      ]
      
      let htmlContent = `
        <html>
        <head>
          <title>Painel de Cancelamentos e Alterações</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { text-align: center; color: #333; }
            h2 { color: #555; margin-top: 30px; border-bottom: 2px solid #ddd; padding-bottom: 5px; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 40px; }
            th { background-color: #f0f0f0; padding: 10px; text-align: left; border: 1px solid #ddd; }
            td { padding: 8px; border: 1px solid #ddd; }
            .total { font-weight: bold; background-color: #f9f9f9; }
          </style>
        </head>
        <body>
          <h1>Painel de Cancelamentos e Alterações</h1>
          <p>Período: ${this.formatarData(this.dt1)} até ${this.formatarData(this.dt2)}</p>
      `
      
      allData.forEach(section => {
        if (section.data.length > 0) {
          htmlContent += `<h2>${section.title}</h2>`
          htmlContent += '<table>'
          htmlContent += '<thead><tr>'
          section.fields.forEach(field => {
            htmlContent += `<th>${field.label}</th>`
          })
          htmlContent += '</tr></thead><tbody>'
          
          section.data.forEach(row => {
            htmlContent += '<tr>'
            section.fields.forEach(field => {
              const value = row[field.key]
              let formattedValue = value
              
              if (field.key.includes('DT_')) {
                formattedValue = this.formatarData(value)
              } else if (field.key.includes('VL_')) {
                formattedValue = this.formatarMoeda(value)
              }
              
              htmlContent += `<td>${formattedValue || '-'}</td>`
            })
            htmlContent += '</tr>'
          })
          
          htmlContent += '</tbody></table>'
        }
      })
      
      htmlContent += '</body></html>'
      
      const blob = new Blob([htmlContent], { type: 'text/html' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'painel-cancelamentos.html'
      a.click()
      URL.revokeObjectURL(url)
    },
    
    exportarExcel() {
      const allData = [
        { title: 'Vendas com Datas Diferentes', data: this.vendasDiferentes, fields: this.fieldsVendasDiferentes },
        { title: 'Alterações de Vendas', data: this.alteracoesVendas, fields: this.fieldsAlteracoesVendas },
        { title: 'A Receber Excluídas', data: this.areceberExcluidas, fields: this.fieldsAReceberExcluidas },
        { title: 'A Pagar Excluídas', data: this.apagarExcluidas, fields: this.fieldsAPagarExcluidas },
        { title: 'Monitoramento do Caixa', data: this.monitoramentoCaixa, fields: this.fieldsMonitoramentoCaixa }
      ]
      
      allData.forEach((section, index) => {
        if (section.data.length > 0) {
          exportExcelXlsx({
            rows: section.data,
            columns: section.fields,
            filename: `painel-cancelamentos-${index + 1}-${section.title.toLowerCase().replace(/\s/g, '-')}.xlsx`
          })
        }
      })
    },
    
    async imprimirVendasDatas() {
      try {
        if (!this.dt1 || !this.dt2) {
          Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Defina o período antes de imprimir')
          return
        }
        
        this.isBusyVendas = true
        const response = await this.$http.post('/api/protected/relatorios/painel-cancelamentos/vendas-datas-diferentes', {
          dt1: this.dt1,
          dt2: this.dt2,
          login: window.localStorage.getItem('login')
        }, { responseType: 'arraybuffer' })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao gerar PDF do relatório')
      } finally {
        this.isBusyVendas = false
      }
    },
    
    async imprimirAlteracoes() {
      try {
        if (!this.dt1 || !this.dt2) {
          Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Defina o período antes de imprimir')
          return
        }
        
        this.isBusyAlteracoes = true
        const response = await this.$http.post('/api/protected/relatorios/painel-cancelamentos/alteracoes-vendas', {
          dt1: this.dt1,
          dt2: this.dt2,
          login: window.localStorage.getItem('login')
        }, { responseType: 'arraybuffer' })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao gerar PDF do relatório')
      } finally {
        this.isBusyAlteracoes = false
      }
    },
    
    async imprimirAReceber() {
      try {
        if (!this.dt1 || !this.dt2) {
          Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Defina o período antes de imprimir')
          return
        }
        
        this.isBusyAReceber = true
        const response = await this.$http.post('/api/protected/relatorios/painel-cancelamentos/areceber-excluidas', {
          dt1: this.dt1,
          dt2: this.dt2,
          login: window.localStorage.getItem('login')
        }, { responseType: 'arraybuffer' })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao gerar PDF do relatório')
      } finally {
        this.isBusyAReceber = false
      }
    },
    
    async imprimirAPagar() {
      try {
        if (!this.dt1 || !this.dt2) {
          Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Defina o período antes de imprimir')
          return
        }
        
        this.isBusyAPagar = true
        const response = await this.$http.post('/api/protected/relatorios/painel-cancelamentos/apagar-excluidas', {
          dt1: this.dt1,
          dt2: this.dt2,
          login: window.localStorage.getItem('login')
        }, { responseType: 'arraybuffer' })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao gerar PDF do relatório')
      } finally {
        this.isBusyAPagar = false
      }
    },
    
    async imprimirCaixa() {
      try {
        if (!this.dt1 || !this.dt2) {
          Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Defina o período antes de imprimir')
          return
        }
        
        this.isBusyCaixa = true
        const response = await this.$http.post('/api/protected/relatorios/painel-cancelamentos/monitoramento-caixa', {
          dt1: this.dt1,
          dt2: this.dt2,
          login: window.localStorage.getItem('login')
        }, { responseType: 'arraybuffer' })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao gerar PDF do relatório')
      } finally {
        this.isBusyCaixa = false
      }
    }
  },
  
  mounted() {
    // Definir o período padrão como hoje
    const hoje = new Date()
    const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    
    this.dt1 = primeiroDiaMes.toISOString().split('T')[0]
    this.dt2 = hoje.toISOString().split('T')[0]
  }
}
</script>

<style scoped>
.list-header-premium {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.header-icon-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.modern-premium-table {
  font-size: 0.9rem;
}

.modern-premium-table tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.05);
}

.gap-3 {
  gap: 1rem;
}

.gap-2 {
  gap: 0.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.btn-icon-only {
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
}

/* Responsividade Mobile */
@media (max-width: 991px) {
  .date-inputs-responsive {
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
  
  .btn-filtrar-responsive {
    width: 100%;
    margin-top: 0.25rem;
  }
}

@media (max-width: 767px) {
  .list-header-premium {
    gap: 0.5rem !important;
    padding-bottom: 1rem !important;
  }
  
  .list-header-premium .p-3 {
    padding: 0.75rem !important;
  }
  
  .search-pill-responsive {
    width: 100%;
    margin-right: 0 !important;
    border-radius: 1.5rem !important;
  }
}

@media (max-width: 575px) {
  .date-inputs-responsive .mx-1 {
    width: 120px !important;
    margin: 0.25rem !important;
  }
  
  .btn-filtrar-responsive .fa-search {
    margin-right: 0 !important;
  }

  .header-icon-wrapper {
    width: 38px;
    height: 38px;
  }
  
  .header-text-container h4 {
    font-size: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/PainelCancelamentos.vue